<script lang="ts">
	import { TextRowSelector } from "misc-ui"
	import { mobileScrollFade, Responsive } from "responsive"
	import { ProjectorMenuController, type ProjectorMenuView } from "./ProjectorMenuController.svelte"
	import { ProjectorPreferencesManager } from "./ProjectorPreferenceManager.svelte"
	import { Toast } from "toaster"

	let selectedDevice = $derived(ProjectorMenuController.ctx.device)
	let selectableViews = $derived(
		ProjectorMenuController.getSelectableViewsFromDevice(selectedDevice).sort()
	)

	let isMobile = $derived(Responsive.isMobile)
	let selectedView = $derived(ProjectorMenuController.ctx.view)

	// if there are any changes to device preferences pending
	let changesPending = $derived(
		Object.values(ProjectorPreferencesManager.pendingChanges).length > 0
	)

	let areChangesApplying = $state(false)

	async function applyChanges() {
		areChangesApplying = true
		Toast.text("Saving settings...")
		try {
			await ProjectorPreferencesManager.applyChanges()
			Toast.success("Settings saved successfully!")
		} catch (e) {
			console.error("UNABLE TO SAVE DEVICE SETTINGS", e)
			Toast.error("Unable to save settings. Please refresh and try again...")
		}
		areChangesApplying = false
	}
</script>

<div class="menu-navigator" class:isMobile>
	<div class="fade-wrapper" use:mobileScrollFade>
		<TextRowSelector
			onChange={ProjectorMenuController.setView}
			selectedOption={selectedView}
			options={selectableViews}
			optionInfo={{
				Calibration: `Calibration is the process of shining and capturing patterns from your Luxedo in order to accurately map your projection space.`,
				Settings: `These settings are intended for advanced users or specific troubleshooting scenarios. Most users won't need to tinker with them.`,
			}}
			fontSize={isMobile ? "var(--h2)" : "var(--h1)"}
		/>
	</div>
	{#if changesPending}
		<button id="save-device-settings-button" onclick={applyChanges} disabled={areChangesApplying}
			>Save</button
		>
	{/if}
</div>

<style>
	.menu-navigator {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 1rem;
		position: relative;
	}

	.menu-navigator :global(.text-row-selector button.link-button) {
		border: none;
	}

	.fade-wrapper {
		overflow-x: auto;
		padding-bottom: 0.25rem;
	}

	#save-device-settings-button {
		margin-left: 1rem;
		width: fit-content;
	}

	.isMobile button {
		font-size: var(--h3);
	}
</style>
